<template>
    <v-app>
        <v-content>
            <v-container class="fill-height">
                <v-row align="center" justify="center">
                    <v-col v-if="status === null" cols="6" md="4">
                        <p class="text-center">
                            Memuat
                        </p>

                        <v-progress-linear indeterminate color="primary"></v-progress-linear>
                    </v-col>

                    <v-col v-else-if="status === GROUP_NOT_FOUND" cols="12">
                        <h1 class="display-1 text-center">Tidak ditemukan</h1>

                        <p class="text-center mt-4">
                            Tidak ditemukan kelompok dengan invite link <code>{{ inviteLink }}</code>.
                            <br />Gunakan invite link yang didapat dari ketua kelompok untuk bergabung ke kelompok.
                        </p>
                    </v-col>

                    <v-col v-else cols="12" sm="10" md="8" lg="6">
                        <h1 class="title text-center mb-6">Bergabung dengan kelompok: {{ group.name }}</h1>

                        <v-sheet class="elevation-2 pa-4">
                            <join-confirmation v-if="status === USER_JOIN"></join-confirmation>

                            <signup-or-login v-else-if="status === USER_AUTH"></signup-or-login>
                        </v-sheet>
                    </v-col>
                </v-row>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
import hasLocalToken from '@/tools/hasLocalToken'
import { sync } from 'vuex-pathify'
import { GROUP_NOT_FOUND, USER_JOIN, USER_AUTH } from '@/store/groupjoin'
import SignupOrLogin from '@/components/groupjoin/SignupOrLogin'
import JoinConfirmation from '@/components/groupjoin/JoinConfirmation'

export default {
    components: {
        JoinConfirmation,
        SignupOrLogin,
    },

    data() {
        return {
            GROUP_NOT_FOUND,
            USER_JOIN,
            USER_AUTH
        }
    },

    computed: {
        inviteLink() {
            return window.location
        },

        ...sync('groupjoin/*'),
    },

    created() {
        this.groupHash = this.$route.params.group_hash

        this.$api.get(`group/${this.groupHash}`)
            .then(response => {
                this.group = response.data
                this.groupRoute = response.data.is_active ? 'group' : 'groupPayment'

                if (hasLocalToken()) {
                    this.$api.get('auth')
                        .then(response => {
                            this.$store.dispatch('auth/setDataFromAuth', response.data)

                            if (response.data.group_hash === this.$route.params.group_hash) {
                                // If user already in group
                                if (response.data.is_group_active) {
                                    this.$router.replace({ name: 'group' })
                                } else {
                                    this.$router.replace({ name: 'groupPayment' })
                                }
                            } else {
                                this.status = this.USER_JOIN
                            }
                        })
                        .catch(() => {
                            this.status = this.USER_AUTH
                        })
                } else {
                    this.status = this.USER_AUTH
                }
            })
            .catch(error => {
                if (error.response.status === 404) {
                    this.status = this.GROUP_NOT_FOUND
                }
            })
    },

    destroyed() {
        this.$store.commit('groupjoin/RESET')
    }
}
</script>
